import { Link } from "react-router-dom";

const LOGO_URL =
  "https://static.readdy.ai/image/9bd046423ff55e49be43d604c216515f/748f9bdfc4c6ea0c2a13ac200d412f03.png";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Platforms & Apps", path: "/platforms" },
  { label: "Join as BIGO Host", path: "/join-bigo" },
  { label: "Contact", path: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-brand-dark border-t-2 border-gold/30">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-14 h-14 flex items-center justify-center">
                <img
                  src={LOGO_URL}
                  alt="LittyCity Agency LLC"
                  className="w-14 h-14 object-contain"
                />
              </div>
              <div>
                <p className="text-white font-display font-bold text-lg leading-tight tracking-wider">
                  THE LITTY<span className="text-gradient-gold">CITY</span>
                </p>
                <p className="text-gold text-xs tracking-[0.25em] font-sans">
                  AGENCY LLC
                </p>
              </div>
            </div>
            <p className="text-white/50 text-sm font-sans leading-relaxed mb-6">
              Where Creators, Hosts &amp; Brands Stay Lit. A full-service digital
              agency empowering creators across platforms since 2024.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: "ri-instagram-line", href: "#" },
                { icon: "ri-youtube-line", href: "#" },
                { icon: "ri-tiktok-line", href: "#" },
                { icon: "ri-twitter-x-line", href: "#" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-gold/30 text-gold hover:bg-gold hover:text-black transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-gold text-xs font-sans font-semibold tracking-[0.25em] uppercase mb-6">
              Navigation
            </h4>
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/60 text-sm font-sans hover:text-gold transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-gold text-xs font-sans font-semibold tracking-[0.25em] uppercase mb-6">
              Get in Touch
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href="https://wa.me/18453701756"
                className="flex items-center gap-3 text-white/60 text-sm font-sans hover:text-gold transition-colors duration-300 cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-full border border-gold/30">
                  <i className="ri-whatsapp-line text-gold text-base" />
                </div>
                1-845-370-1756
              </a>
              <a
                href="mailto:Mswashington@thelittyagency"
                className="flex items-center gap-3 text-white/60 text-sm font-sans hover:text-gold transition-colors duration-300 cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-full border border-gold/30">
                  <i className="ri-mail-line text-gold text-base" />
                </div>
                Mswashington@thelittyagency
              </a>
              <Link
                to="/contact"
                className="mt-2 inline-flex items-center gap-2 px-5 py-2.5 bg-gold text-white text-sm font-medium font-sans tracking-wider rounded-full hover:bg-gold-light transition-colors duration-300 whitespace-nowrap w-fit"
              >
                <i className="ri-send-plane-line" />
                Send a Message
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gold/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs font-sans">
            &copy; {new Date().getFullYear()} The LittyCity Agency LLC. All rights reserved. Founded 2024.
          </p>
          <p className="text-white/20 text-xs font-sans">
            Empowering Creators Across Every Platform
          </p>
        </div>
      </div>
    </footer>
  );
}
